var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("common.security.ssh"),
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "b-row",
                {
                  staticClass:
                    "d-flex justify-content-center align-items-center",
                },
                [
                  _vm.isRightPod
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c(
                            "div",
                            [
                              _c("span", { staticClass: "filter-item-title" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("common.security.pod_select"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "color-red" }, [
                                _vm._v("* "),
                              ]),
                              _vm._v(" "),
                              _c("b-form-select", {
                                staticStyle: { "font-size": "small" },
                                attrs: { options: _vm.podList },
                                model: {
                                  value: _vm.form.pod,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "pod", $$v)
                                  },
                                  expression: "form.pod",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("common.security.name"),
                          placeholderValue: _vm.$t("common.security.name"),
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("common.security.public_key"),
                isTitleUpperCase: false,
              },
            },
            [
              this.id != -1
                ? _c("div", [
                    _vm.form.statePublicKey === 1
                      ? _c(
                          "button",
                          {
                            staticClass: "btn w-auto px-4 btn-tertiary mb-5",
                            on: { click: _vm.updatePublicKey },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("common.security.cancel_public_key")
                              )
                            ),
                          ]
                        )
                      : _c(
                          "button",
                          {
                            staticClass: "btn w-auto px-4 btn-tertiary mb-5",
                            on: { click: _vm.cancelPublicKey },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("common.security.update_public_key")
                              )
                            ),
                          ]
                        ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.form.statePublicKey === 1
                ? _c(
                    "b-row",
                    {
                      staticClass:
                        "d-flex justify-content-center align-items-center",
                    },
                    [
                      _vm.publicKeyText === ""
                        ? _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c("span", { staticClass: "filter-item-title" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("common.security.public_key_file")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "color-red" }, [
                                _vm._v("* "),
                              ]),
                              _vm._v(" "),
                              _c("b-form-textarea", {
                                staticStyle: { "max-height": "none" },
                                attrs: {
                                  id: "textarea",
                                  placeholder: _vm.$t("common.enter_something"),
                                  rows: "6",
                                },
                                on: { input: _vm.processPublicKey },
                                model: {
                                  value: _vm.publicKeyText,
                                  callback: function ($$v) {
                                    _vm.publicKeyText = $$v
                                  },
                                  expression: "publicKeyText",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.publicKeyText === ""
                        ? _c(
                            "b-col",
                            {
                              staticClass: "form-group d-flex flex-column",
                              attrs: { sm: "6" },
                            },
                            [
                              _c("span", [
                                _c(
                                  "span",
                                  { staticClass: "filter-item-title" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "common.security.public_key_file"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "color-red" }, [
                                  _vm._v("* "),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                attrs: { type: "file" },
                                on: { change: _vm.handleFileUploadPublicKey },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.publicKeyText !== "" && _vm.form.statePublicKey === 1
                ? _c(
                    "b-row",
                    {
                      staticClass:
                        "d-flex justify-content-center align-items-center",
                    },
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "12" } },
                        [
                          _c("span", { staticClass: "filter-item-title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("common.security.public_key_file"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "color-red" }, [
                            _vm._v("* "),
                          ]),
                          _vm._v(" "),
                          _c("b-form-textarea", {
                            staticStyle: { "max-height": "none" },
                            attrs: {
                              id: "textarea",
                              placeholder: _vm.$t("common.enter_something"),
                              rows: "6",
                            },
                            on: { input: _vm.processPublicKey },
                            model: {
                              value: _vm.publicKeyText,
                              callback: function ($$v) {
                                _vm.publicKeyText = $$v
                              },
                              expression: "publicKeyText",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.publicKeyText === ""
                        ? _c(
                            "b-col",
                            {
                              staticClass: "form-group d-flex flex-column",
                              attrs: { sm: "6" },
                            },
                            [
                              _c("span", [
                                _c(
                                  "span",
                                  { staticClass: "filter-item-title" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "common.security.certificat_file"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "color-red" }, [
                                  _vm._v("* "),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                attrs: { type: "file" },
                                on: { change: _vm.handleFileUploadPublicKey },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("common.security.private_key"),
                isTitleUpperCase: false,
              },
            },
            [
              this.id !== -1
                ? _c("div", [
                    _vm.form.statePrivateKey === 1
                      ? _c(
                          "button",
                          {
                            staticClass: "btn w-auto px-4 btn-tertiary mb-5",
                            on: { click: _vm.updatePrivateKey },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("common.security.cancel_privatekey")
                              )
                            ),
                          ]
                        )
                      : _c(
                          "button",
                          {
                            staticClass: "btn w-auto px-4 btn-tertiary mb-5",
                            on: { click: _vm.cancelPrivateKey },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("common.security.update_privatekey")
                              )
                            ),
                          ]
                        ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.form.statePrivateKey === 1
                ? _c(
                    "b-row",
                    {
                      staticClass:
                        "d-flex justify-content-center align-items-center",
                    },
                    [
                      _vm.privateKeyText === "" &&
                      _vm.form.statePrivateKey === 1
                        ? _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c("span", { staticClass: "filter-item-title" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("common.security.private_key_file")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "color-red" }, [
                                _vm._v("* "),
                              ]),
                              _vm._v(" "),
                              _c("b-form-textarea", {
                                staticStyle: { "max-height": "none" },
                                attrs: {
                                  id: "textarea",
                                  placeholder: _vm.$t("common.enter_something"),
                                  rows: "6",
                                },
                                on: { input: _vm.processPrivateKey },
                                model: {
                                  value: _vm.privateKeyText,
                                  callback: function ($$v) {
                                    _vm.privateKeyText = $$v
                                  },
                                  expression: "privateKeyText",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.privateKeyText !== "" &&
                      _vm.form.statePrivateKey === 1
                        ? _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "12" } },
                            [
                              _c("span", { staticClass: "filter-item-title" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("common.security.private_key_file")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "color-red" }, [
                                _vm._v("* "),
                              ]),
                              _vm._v(" "),
                              _c("b-form-textarea", {
                                staticStyle: { "max-height": "none" },
                                attrs: {
                                  id: "textarea",
                                  placeholder: _vm.$t("common.enter_something"),
                                  rows: "6",
                                },
                                on: { input: _vm.processPrivateKey },
                                model: {
                                  value: _vm.privateKeyText,
                                  callback: function ($$v) {
                                    _vm.privateKeyText = $$v
                                  },
                                  expression: "privateKeyText",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.privateKeyText === "" &&
                      _vm.form.statePrivateKey === 1
                        ? _c(
                            "b-col",
                            {
                              staticClass: "form-group d-flex flex-column",
                              attrs: { sm: "6" },
                            },
                            [
                              _c("span", [
                                _c(
                                  "span",
                                  { staticClass: "filter-item-title" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "common.security.private_key_file"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "color-red" }, [
                                  _vm._v("* "),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                attrs: { type: "file" },
                                on: { change: _vm.handleFileUploadPrivateKey },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("common.security.password"),
                          placeholderValue: _vm.$t("common.security.password"),
                        },
                        model: {
                          value: _vm.form.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "password", $$v)
                          },
                          expression: "form.password",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col", {
                    staticClass: "form-group",
                    attrs: { sm: "6" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3 justify-content-end" },
        [
          _vm.canSaveSSH
            ? _c(
                "b-col",
                { attrs: { cols: "4", lg: "2", xl: "1" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.updateSSH()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-save" }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("common.security.update_ssh"))),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _c(
                "b-col",
                { attrs: { cols: "4", lg: "2", xl: "1" } },
                [
                  _c(
                    "b-button",
                    { attrs: { variant: "primary", disabled: "" } },
                    [
                      _c("i", { staticClass: "fa-light fa-save" }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("common.security.update_ssh"))),
                      ]),
                    ]
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }